module.exports = __webpack_public_path__ + "img/ninetynine.1f28cabe.png";